import IconButton from "components/common/IconButton";
import useCopyToClipboard from "hooks/useCopyToClipboard";
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import PropTypes from 'prop-types';
import { useToast } from 'context/providers/ToastProvider';

const CopyButton = ({ code, duration = 5000 }) => {
    const { showSuccessToast } = useToast();
    const [isCopied, handleCopy] = useCopyToClipboard(duration);

    return (
        <>
            <IconButton
                onClick={
                    () => {
                        handleCopy(code);
                        showSuccessToast('Copiado en el portapapeles: ' + code);
                    }
                }
                variant="falcon-default"
                size="sm"
                icon=""
            >
                <OverlayTrigger
                    placement="right"
                    overlay={
                        <Tooltip style={{ position: 'fixed' }} id="overlay-trigger-example">
                            <span>Copiar</span>
                        </Tooltip>
                    }
                >
                    {isCopied ? <img src="/img/check25.png"></img> : <img src="/img/copiar25.png"></img>}
                </OverlayTrigger>
            </IconButton>
        </>
    );
}

CopyButton.propTypes = {
    code: PropTypes.string,
    duration: PropTypes.number
};

export default CopyButton;